import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'

export default class AnimationSequence {
  animations: IAnimationTrack[] = []

  add(animation: IAnimationTrack) {
    this.animations.push(animation)
  }

  init() {
    this.animations.forEach((a) => a.init())
  }

  play(): Promise<unknown> {
    const promises = this.animations.map((a) => a.play())
    return Promise.all(promises)
  }
}
